import AdmissionCardHome from "./../../CourseRegistration/AdmissionCardHome";
const WebinarRegistration = () => {
  const male_group_link = "https://t.me/+hGSU1E7au-05NDg0";

  // <section>
  //   <div className="container mx-auto my-10 px-5">
  //     <p className="text-xl text-blue-600 mt-10 mb-5 text-center">
  //       রেজিস্ট্রেশন করুন
  //     </p>

  //     <div className="mx-auto my-5 text-center ">
  //       <ul className="steps steps-vertical">
  //         <li className="step step-primary">
  //           <a href="#send-money">২০০ টাকা সেন্ডমানি করুন</a>
  //         </li>
  //         <li className="step step-primary">
  //           <a href="#reg-form">ভর্তি ফর্ম পূরণ করুন</a>
  //         </li>
  //         <li className="step step-primary">
  //           <a href="#group-link">টেলিগ্রাম গ্রুপে জয়েন করুন</a>
  //         </li>
  //       </ul>
  //     </div>
  //     <WebinarForm />

  //     <div>
  //       <p className="text-xl text-blue-600 mt-24">গ্রুপে জয়েন করুন</p>
  //       <p>আপনার পেমেন্ট চেক করে গ্রুপে অ্যাড করা হবে।</p>

  //       <a
  //         className="inline-block my-3"
  //         target="_blank"
  //         href="https://t.me/+hGSU1E7au-05NDg0"
  //         rel="noreferrer"
  //       >
  //         <p className="px-3 py-1 bg-blue-400 rounded-md">টেলিগ্রাম গ্রুপ</p>
  //       </a>
  //     </div>

  //     <section className="mb-40">
  //       <p className="text-xl text-blue-600 mt-24">সেন্ডমানি করুন</p>
  //       <AsmaulHusnaPayment />
  //     </section>
  //   </div>
  // </section>
  return (
    <div className="my-60">
      <p className="text-xl text-blue-600 mt-10 mb-5 text-center">
        ওয়েবিনারে ভর্তির সময় সময় শেষ।
      </p>
      {/* <WebinarForm /> */}
      <div className="container mx-auto">
        <AdmissionCardHome />
      </div>
    </div>
  );
};

export default WebinarRegistration;
